import { gql } from '@apollo/client'

import { RESERVATION_FRAGMENT } from '../../fragments/customer/reservation'

export const GET_CURRENT_CUSTOMER_RESERVATIONS = gql`
  query CurrentCustomerReservations {
    currentCustomer {
      id
      reservations {
        ...ReservationFields
      }
    }
  }
  ${RESERVATION_FRAGMENT}
`
